import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { RessourcesModule } from '@ressources/client/ressources.module';
import { ProgressBarComponent } from '@shared/client/components/progress-bar/progress-bar.component';

export interface SelectAllProgressModalData {
    total: number;
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProgressBarComponent, RessourcesModule],
    selector: 'app-select-all-progress-modal',
    templateUrl: './select-all-progress-modal.component.html',
})
export class SelectAllProgressModalComponent {
    public readonly entitiesLoaded = signal<number>(0);

    protected readonly data = inject<SelectAllProgressModalData>(MAT_DIALOG_DATA);
}
